import { get } from 'svelte/store';
import { SoundsMode } from './sound-types';
export class SoundModeAwareSoundPlayer {
    constructor(soundModeStore, target) {
        this.soundModeStore = soundModeStore;
        this.target = target;
        this.soundModeStore.subscribe(mode => {
            switch (mode) {
                case SoundsMode.NONE:
                    this.muteNewMessageNotification();
                    this.muteNewConversationNotificationLoop();
                    break;
                case SoundsMode.IMPORTANT:
                    this.muteNewMessageNotification();
                    this.unmuteNewConversationNotificationLoop();
                    break;
                case SoundsMode.ALL:
                    this.unmuteNewMessageNotification();
                    this.unmuteNewConversationNotificationLoop();
                    break;
            }
        });
    }
    preload() {
        return this.target.preload();
    }
    async playNewMessageNotification() {
        return await this.target.playNewMessageNotification();
    }
    muteNewMessageNotification() {
        this.target.muteNewMessageNotification();
    }
    unmuteNewMessageNotification() {
        this.target.unmuteNewMessageNotification();
    }
    async playNewConversationNotificationLoop() {
        return await this.target.playNewConversationNotificationLoop();
    }
    muteNewConversationNotificationLoop() {
        this.target.muteNewConversationNotificationLoop();
    }
    unmuteNewConversationNotificationLoop() {
        this.target.unmuteNewConversationNotificationLoop();
    }
    async stopNewConversationNotificationLoop() {
        return await this.target.stopNewConversationNotificationLoop();
    }
}
